import IMask from "imask";
import moment from "moment";
const forms = document.querySelectorAll(".form");
forms.forEach((form) => {
    const inputs = form.querySelectorAll("input");
    const formatInput = (input, mask) => {
        switch (mask) {
            case "id_username":
                IMask(input, "000`.000`.000`-00");
                break;
            case "id_celular":
                IMask(input, "`(00`)` 00000`-0000");
                break;
            case "id_data_nascimento":
                const momentFormat = "DD/MM/YYYY";
                IMask(input, {
                    mask: Date,
                    pattern: momentFormat,
                    min: new Date(1500, 0, 1),
                    max: new Date(),
                    format: (date) => moment(date).format(momentFormat),
                    parse: (str) => moment(str, momentFormat),
                    blocks: {
                        YYYY: {
                            mask: IMask.MaskedRange,
                            from: 1500,
                            to: 5000,
                        },
                        MM: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 12,
                        },
                        DD: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 31,
                        },
                    },
                });
                break;
        }
    };
    const togglePassword = (input) => {
        if (input.type === "password") {
            const field = input.closest(".field");
            const toggleButton = field?.querySelector(".toggle-password");
            toggleButton?.addEventListener("click", () => {
                if (input.hasAttribute("data-shown")) {
                    input.removeAttribute("data-shown");
                    input.setAttribute("data-hide", "");
                    input.type = "password";
                    toggleButton.style.backgroundImage =
                        "url(/etanol/static/public/images/icon-show-password.svg)";
                }
                else {
                    input.removeAttribute("data-hide");
                    input.setAttribute("data-shown", "");
                    input.type = "text";
                    toggleButton.style.backgroundImage =
                        "url(/etanol/static/public/images/icon-hide-password.svg)";
                }
            });
        }
    };
    inputs.forEach((input) => {
        formatInput(input, input.id);
        togglePassword(input);
    });
});
